module.exports = __webpack_public_path__ + "media/images/lb/524-ad3332473231d8c16c610f92c01f7c32.svg";